import { render, staticRenderFns } from "./CommentDialog.vue?vue&type=template&id=546c2fac&scoped=true&"
import script from "./CommentDialog.vue?vue&type=script&lang=ts&"
export * from "./CommentDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CommentDialog.vue?vue&type=style&index=0&id=546c2fac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546c2fac",
  null
  
)

export default component.exports